import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/user';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { TravelService } from '../../services/travel/travel.service';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { travelAuthorUrl, travelApproveUrl } from 'src/app/modules/shared/common/api';
import { Travel } from 'src/app/models/travel';
import { TravelApproverViewComponent } from '../travel-approver-view/travel-approver-view.component';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-travel-approver',
  templateUrl: './travel-approver.component.html',
  styleUrls: ['./travel-approver.component.scss']
})
export class TravelApproverComponent implements OnInit {

  keyWords = {};
  newKeyWords = {};
  menuList = [
    {
      label:"Date Submitted",
      type: 'date',
      name:"date_submitted",
      value: [],
    },
    {
      label:"Purpose",
      type:"input",
      name:"purpose",
    },
    {
      label:"Location",
      type:"input",
      name:"location",
    },
    {
      label:"Status",
      type:"select",
      name:"status",
      value: ["Approved", "Closed", "For 1st Approval","For 2nd Approval", "For Confirmation", "For Liquidation", "For Liquidation - Overdue", "Rejected","Pushed Back"]
    }
  ];
  
  pipe = new DatePipe('en-US');

  isNoResult: boolean = false;
  loading:boolean = false;
  isKeyWord:boolean = false;
  isRole:boolean = false;
  keyTable = '';
  params:any;

  totalRec : number;
  page: number = 1;
  perPage: number;
  _user = new User('');

  travel: any;
  dialogConfig:any;
  departmentList:any;
  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public travelService: TravelService,
    public functionService: FunctionsService,
    private route: ActivatedRoute
  ) { 
    this.isRole = this._user.getRole();
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      travel_authorization_no:['',null],
      complete_name: ['',null],
      date_filed: ['',null],
      purpose:['',null],
      date_submitted: ['',null],
      location: ['',null],
      status: ['',null],
      dashboard: ['',null],
      department_filter:['',null],
      
      // Version 1.5
      travel_request:['',null],
      travel_type:['',null],
      travel_request_type:['',null],
    });

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

    if (this.isRole) {
      this.menuList.unshift({
        label:"Requestor",
        type:"input",
        name:"complete_name"
      });
      this.travelService.getDepartment().subscribe(res=>{
        this.departmentList = res;
        this.menuList.unshift({
          label:"Department",
          type:"select",
          name:"department_filter",
          value: this.departmentList,
        });
      });
    }

    //check status param router if set
    this.route.queryParams.subscribe( params =>{
      if (params['email']) {
        this.params = params;
        this.formGroup.controls['travel_request'].setValue(params['email']);
        this.getFilter();
        return;
      } else if (params['status'] || params['dashboard'] || params['travel_type']) {
        this.formGroup.controls['status'].setValue(params.status);
        this.formGroup.controls['dashboard'].setValue(params.dashboard);
        this.formGroup.controls['travel_type'].setValue(params.travel_type);
        this.formGroup.controls['travel_request_type'].setValue(params.travel_request_type);
        if (this.formGroup.controls['status'].value && this.formGroup.controls['dashboard'].value) {
          this.newKeyWords = {status: this.formGroup.controls['status'].value, dashboard: this.formGroup.controls['dashboard'].value}
        }
        this.getFilter();
      } else {
        this.keyWords = {};
        this.getList();
      }
    });
 
  }

  getFilter() {
    this.page = 1;
    this.isKeyWord = true;
    if (this.isKeyWord) {
      this.keyTable = 'table-chiplist';
    }
    if(this.formGroup.controls['date_submitted'].value !== '' && this.formGroup.controls['date_submitted'].value !== null){
      this.formGroup.controls['date_submitted'].setValue(this.pipe.transform(this.formGroup.controls['date_submitted'].value, 'yyyy-MM-dd'));
    }
    this.getList();
    if (Object.keys(this.newKeyWords).length > 0) {
      delete this.newKeyWords['dashboard'];
      this.keyWords = this.newKeyWords;
    } else {
      this.keyWords = [];
      this.keyWords = this.functionService.filter(this.formGroup,this.keyWords);
    }
  }

  getList() {
    let param = [];
    let queryString = '';

    if (this.page) {
      param.push('page='+this.page);
    }  

    // Version 1.5
    if(this.formGroup.controls['travel_request'].value !== null){
      param.push('travel_request='+encodeURIComponent(this.formGroup.controls['travel_request'].value));
    }

    if(this.formGroup.controls['travel_authorization_no'].value !== null){
      param.push('travel_authorization_no='+encodeURIComponent(this.formGroup.controls['travel_authorization_no'].value));
    }

    if(this.formGroup.controls['complete_name'].value !== null){
      param.push('complete_name='+this.formGroup.controls['complete_name'].value);
    }

    if(this.formGroup.controls['department_filter'].value !== null){
      param.push('department_filter='+this.formGroup.controls['department_filter'].value);
    }
    
    if(this.formGroup.controls['date_submitted'].value !== null){
      param.push('date_submitted='+this.formGroup.controls['date_submitted'].value);
    }

    if(this.formGroup.controls['status'].value !== null){
      param.push('status='+this.formGroup.controls['status'].value);
    }

    if(this.formGroup.controls['dashboard'].value !== null){
      param.push('dashboard='+this.formGroup.controls['dashboard'].value);
    }

    if(this.formGroup.controls['purpose'].value !== null){
      param.push('purpose='+this.formGroup.controls['purpose'].value);
    }

    if(this.formGroup.controls['location'].value !== null){
      param.push('location='+this.formGroup.controls['location'].value);
    }

    if(this.formGroup.controls['travel_type'].value !== null){
      param.push('travel_type='+this.formGroup.controls['travel_type'].value);
    }

    if(this.formGroup.controls['travel_request_type'].value !== null){
      param.push('travel_request_type='+this.formGroup.controls['travel_request_type'].value);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.travelService.url = travelApproveUrl+''+ queryString;
    this.travelService.getFilter().subscribe(res=>{
      if (res.data) {
        this.travel = new Travel(res.data);
      }
      if (this.params) {
        if (res.data[0]) {
          this.openDetail(res.data[0]);
          this.params = '';
        }
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  onClearForm() {
    this.formGroup.reset();
    this.keyWords = [];
    this.getList();
    this.isKeyWord  = false;
    this.keyTable = '';
  }

  openDetail(res) {
    this.dialogConfig.data = {res};
    this.dialogConfig.width = '100vw';
    let dialogRef = this.dialog.open(TravelApproverViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getList();
      }
    });
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }
  
  removeKeywords(key){
    this.formGroup.controls[key].setValue('');
    this.functionService.removeFilter(this.keyWords,key);
    this.getList();
    this.keyTable = '';
  }
}